import isEmpty from 'lodash/isEmpty'
import { dateTimeFormatters } from '@src/utils/date-formatters'
const { dateStartOf, currentdateStartOf } = dateTimeFormatters()

export default {
  primaryColor (state) {
    return state.settings && state.settings.primaryColor && state.settings.primaryColor.hex
  },
  primaryColorRgb (state) {
    return state.settings && state.settings.primaryColor && state.settings.primaryColor.rgb &&
      `${state.settings.primaryColor.rgb.r}, ${state.settings.primaryColor.rgb.g}, ${state.settings.primaryColor.rgb.b}`
  },
  secondaryColorRgb (state) {
    return state.settings && state.settings.secondaryColor && state.settings.secondaryColor.rgb &&
      `${state.settings.secondaryColor.rgb.r}, ${state.settings.secondaryColor.rgb.g}, ${state.settings.secondaryColor.rgb.b}`
  },
  loggedIn (state) {
    return state.user && state.user !== undefined && state.user !== null
  },
  home (state, getters) {
    return getters.pages.find(page => page._type === 'page' && page.slug.current === 'home')
  },
  pages (state) {
    // If we find a draft page. We need to prioritize that for previews
    const filterDrafts = state.pages.filter(page => page._type === 'page' && page._id.includes('draft'))
    if (filterDrafts.length === 0) {
      return state.pages.filter(page => page._type === 'page')
    } else {
      // We have drafts. Lets use those instead of the originals
      return state.pages.filter(page => page._type === 'page' && !filterDrafts.map(draftPage => draftPage._id.replace('drafts.', '')).includes(page._id))
    }
  },
  challengePages (state, getters) {
    return getters.pages.filter(page => page._type === 'page' && page.slug.current.includes('challenge'))
  },
  confirmation (state) {
    return state.pages.filter(page => page._type === 'page' && page.slug.current.includes('confirmation'))
  },
  activeChallenge (state) {
    return state.activeChallengePage && state.activeChallengePage.challenge && state.activeChallengePage.challenge.stripeSku ? state.challenges.find(challengeProduct => {
      if (challengeProduct.plans.length) {
        return challengeProduct.id === state.activeChallengePage.challenge.stripeSku || challengeProduct.plans.find(price => price.id === state.activeChallengePage.challenge.stripeSku)
      }
    }) : null
  },
  activeChallengePrice (state, getters) {
    return getters.activeChallenge?.plans && state?.selectedOrder?.sku && getters.activeChallenge.plans.find(price => price.id === state.selectedOrder.sku)
  },
  isChallengeFree (state, getters) {
    return (getters.isAnnualWebOrNativeSubscriber && getters.activeChallengePrice?.metadata?.freeWithAnnual)
  },
  isChallengeFreeForSelectedSubscription (state, getters) {
    return (getters.isAnnualSubscriptionPlanSelected && getters.activeChallengePrice?.metadata?.freeWithAnnual)
  },
  activeSubscription (state) {
    return state && state.user && state.user.customer && state.user.customer.subscriptions && state.user.customer.subscriptions.data.length > 0 ? state.user.customer.subscriptions.data[0] : null
  },
  activeSubscriptionPlan (state, getters) {
    return getters.activeSubscription && getters.activeSubscription.plan
  },
  hasNativeSubscription (state) {
    return state && state.user && state.user.profile && state.user.profile.device_type && state.user.profile.device_type !== 'web'
  },
  hasActiveNativeSubscription (state) {
    return state && state.user && state.user.profile.device_type !== 'web'
      ? ((state.user.profile.expire_date && dateStartOf(state.user.profile.expire_date, 'YYYY-MM-DD', 'day') >= currentdateStartOf('day')) ||
      (state.user.profile.subscribed_plan && state.user.profile.subscribed_plan === '1'))
      : false
  },
  isAnnualWebOrNativeSubscriber (state, getters) {
    if (getters.activeSubscription && getters.activeSubscription.plan && getters.activeSubscription.plan.interval === 'year') {
      // Gateway annual user
      return true
    } else if (getters.hasNativeSubscription && getters.hasActiveNativeSubscription && state.user.profile.subscription_plan_type) {
      if (state.user.profile.subscription_plan_type.includes('year') || state.user.profile.subscription_plan_type.includes('annual') || state.user.profile.subscription_plan_type.includes('anual')) {
        // Native annual user
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  },
  isAnnualSubscriptionPlanSelected (state) {
    if (
      state.selectedSubscription &&
      !isEmpty(state.selectedSubscription) &&
      state.subscriptions.length > 0 &&
      state.subscriptions[0].plans &&
      state.subscriptions[0].plans.length > 0
    ) {
      const isFound = state.subscriptions[0].plans.find(plan => plan && plan.interval === 'year' && plan.id === state.selectedSubscription.id)
      return typeof isFound !== 'undefined'
    } else {
      return false
    }
  },
  isCurrentSubscriptionPlan (state, getters) {
    if (getters.activeSubscription && state.selectedSubscription && getters.activeSubscription.plan.id === state.selectedSubscription.id) {
      return getters.activeSubscription.plan
    } else if (getters.activeSubscription && isEmpty(state.selectedSubscription) && getters.activeSubscription.plan.id) {
      return getters.activeSubscription.plan
    } else {
      return false
    }
  },
  isSubscriptionPlanMatchingLegacy (state, getters) {
    /* TO DO Possibility to check for more than 1 active product with the same interval */
    return getters.activeSubscription && getters.activeSubscription.plan && getters.activeSubscription.plan.interval === state.selectedSubscription.interval && state.selectedSubscription.interval_count === getters.activeSubscription.plan.interval_count
  },
  getAppliedGates (state, getters) {
    if (state.gates && state.gates.length > 0 && state.settings.appliedGates && state.settings.appliedGates.length > 0) {
      return state.gates.filter((gate) => {
        return state.settings.appliedGates.find((appliedGate) => gate._id === appliedGate._ref
        )
      })
    } else {
      return []
    }
  }
}
